import { useEffect, useState } from 'react';
import { listDocumentAssignors } from '../../../../services/documentAssignorsApi';
import { assignorsFromDocuments, OperationPerson } from './collectionAgreementSuggestion';

const useDocumentAssignors = (documentIds: string[]): OperationPerson[] => {
    const [assignors, setAssignors] = useState<OperationPerson[]>([]);
    const key = Array.from(new Set(documentIds.filter(Boolean))).sort().join(',');

    useEffect(() => {
        let active = true;
        const ids = key ? key.split(',') : [];
        listDocumentAssignors(ids)
            .then(documents => { if (active) setAssignors(assignorsFromDocuments(documents)); })
            .catch(() => { if (active) setAssignors([]); });
        return () => { active = false; };
    }, [key]);

    return assignors;
};

export default useDocumentAssignors;
